import React from 'react';

const Fembanner = () => {
  return (
    <div id='fem-banner'>
      <h2 className='header2'>Frontend Mentor</h2>
      <p className='body2'>Feedback Board</p>
    </div>
  );
};

export default Fembanner;
